import React, { useContext } from 'react'
import Heading from '@react/react-spectrum/Heading'
import Link from '../Nav/Link'
import BackButton from '../Nav/BackButton'
import Title from '../Nav/Title'
import Switch from '../Nav/Switch'
import { __ } from 'i18n-for-browser'
import '../../config/i18n'
import useMultilineText from '../hooks/useMultilineText'
import { EasybakeContext } from '../EasybakeProvider'

export default function NavTextLayer () {
    const { page } = useContext(EasybakeContext)
    const summary = useMultilineText(__('textlayer_nav_summary'))
    return (
        <div className="adobe-easybake-nav feature">
            <BackButton className="adobe-easybake-nav-back-button"/>
            <div className="adobe-easybake-nav-content">
                <Title title={__('textlayer_nav_title')} />
                <div className="summary">
                    {summary}
                </div>
                <Link className="adobe-easybake-nav-link" referrer={`documentation:${page}:nav`} label={__('link_doc')} url={__('url_doc_textlayer')} />
                <div className="adobe-easybake-nav-actions">
                    <Heading variant="subtitle2">
                        <Switch group="textlayer" label={__('textlayer_nav_apply_change_font')} action="changefont" position="labelLeft" />
                        <Switch group="textlayer" label={__('textlayer_nav_apply_change_textcolor')} action="changetextcolor" position="labelLeft" />
                        <Switch group="textlayer" label={__('textlayer_nav_apply_change_textweight')} action="changetextweight" position="labelLeft" />
                        <Switch group="textlayer" label={__('textlayer_nav_apply_change_textsize')} action="changetextsize" position="labelLeft" />
                    </Heading>
                </div>
            </div>
        </div>
    )
}
